import { nsSig } from '../img/ns-sig'
import { jsSig } from '../img/js-sig'

export const formS1629 = (form: string): any[] => [
  {
    text: 'Thank you for your recent request to delete your personal information under the California Consumer Privacy Act.',
    marginBottom: 10
  },
  {
    text: `SAFE is unable to comply with your request to delete your personal information, as we retain it to${form === '1629a' ? ':' : ' comply with:'}`,
    marginBottom: 15
  },
  {
    ul: form === '1629a' ? ['Comply with federal and/or state laws and regulations.', 'Maintain accounts or for legal reasons.'] : ['Federal and/or state laws and regulations.', 'Equal employment opportunity laws.'],
    marginBottom: 20,
    marginLeft: 20
  },
  {
    text: [
      { text: 'Rest assured, SAFE is committed to maintaining strong privacy programs that adhere to strict data privacy and security requirements. To learn more, please visit ' },
      { text: 'safecu.org/privacy.', bold: true }
    ],
    marginBottom: 10
  },
  ...formBottom(form)
]

const formBottom = (form: string) => {
  if (form === '1629a') return [
    {
      text: 'If you have any questions, please feel free to contact a helpful SAFE representative at'
    },
    {
      text: [
        { text: '(916) 979-7233 ', bold: true },
        { text: 'or ' },
        { text: '(800) SEE-SAFE.', bold: true }
      ]
    },
    { text: 'Sincerely,', marginBottom: 5, marginTop: 10 },
    { image: nsSig, width: 140, marginBottom: 5 },
    { text: 'Nicole Smith' },
    { text: 'VP, Contact Center' },
    { text: 'SAFE Credit Union' }
  ]
  else return [
    {
      text: [
        { text: 'If  you  have  any  questions, please  feel  free  to  contact  us  at  ' },
        { text: '(800) SEE-SAFE', bold: true },
        { text: ',  extension ' },
      ]
    },
    {
      text: [
        { text: '2556 ', bold: true },
        { text: 'or ' },
        { text: '2399.', bold: true }
      ]
    },
    { text: 'Sincerely,', marginBottom: 5, marginTop: 10 },
    { image: jsSig, width: 140, marginBottom: 5 },
    { text: 'Jenny Santos' },
    { text: 'VP, Human Resources' },
    { text: 'SAFE Credit Union' }
  ]
}